import { ReactNode } from 'react';
import { Button } from '../../../design-system/button/button';
import { Inline } from '../../../design-system/inline/inline';
import { cn } from '../../../utils/cn';

interface DropdownMenuItemProps {
  icon: ReactNode;
  label: string;
  onClick: () => void;
  isFirst?: boolean;
  isLast?: boolean;
  isDanger?: boolean;
}

export const DropdownMenuItem = ({ icon, label, onClick, isFirst, isLast, isDanger }: DropdownMenuItemProps) => {
  return (
    <Button
      variant="ghost"
      size="none"
      aria-label={label}
      onClick={onClick}
      className={cn('w-full rounded-none hover:bg-seapoint-gray-medium', {
        'px-4 pb-3 pt-4': isFirst,
        'rounded-b-xl px-4 pb-4 pt-3': isLast,
        'px-4 py-3': !isFirst && !isLast,
      })}
    >
      <Inline space={4} justify="start" className="w-full">
        <div className="h-4 w-4">{icon}</div>
        <span
          className={cn('text-sm font-normal text-seapoint-gray-text', {
            'text-seapoint-red': isDanger,
          })}
        >
          {label}
        </span>
      </Inline>
    </Button>
  );
};
